const middleware = {}

middleware['maintenance'] = require('../src/middleware/maintenance.js')
middleware['maintenance'] = middleware['maintenance'].default || middleware['maintenance']

export default middleware
